// extracted by mini-css-extract-plugin
export default {"card":"SelectCard_card__Dlk9p","card__subtitle":"SelectCard_card__subtitle__6qdRe","card__amount":"SelectCard_card__amount__V8GTW","card_disabled":"SelectCard_card_disabled__QjnUv"};